"use client";

export default class Utils {
  static removeSpecialCharacters(str) {
    return str.replace(/<[^>]+>/g, "");
  }
  static generateOTP = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };
  static removeSpecialCharactersOnly(text) {
    var words = text.split(/\b/);

    for (var i = 0; i < words.length; i++) {
      words[i] = words[i].replace(/[^\w|]/gi, "");
    }

    return words.join("");
  }

  static generateRandomId() {
    const timestamp = new Date().getTime();
    let idBase = timestamp.toString();

    if (idBase.length < 12) {
      idBase = idBase.padStart(6, "0");
    } else {
      idBase = idBase.substring(idBase.length - 6);
    }

    return idBase;
  }

  static minsToHMS(minutes) {
    const hrs = Math.floor(minutes / 60);
    const mins = Math.floor(minutes % 60);
    const secs = Math.floor((minutes % 1) * 60); // for fractional mins if needed
    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(
      2,
      "0"
    )}:${String(secs).padStart(2, "0")}`;
  }

  static getTimeIntervals(openingTime, closingTime, interval) {
    const intervals = [];
    let start = new Date(`1970-01-01T${openingTime}Z`);
    const end = new Date(`1970-01-01T${closingTime}Z`);

    if (end <= start) {
      end.setDate(end.getDate() + 1);
    }

    while (start <= end) {
      intervals.push(start.toISOString().substr(11, 5));
      start.setMinutes(start.getMinutes() + interval);
    }

    return intervals;
  }

  static getCurrentTime() {
    var d = new Date();
    var hours = d.getHours();
    var minutes = d.getMinutes();

    return hours + ":" + minutes;
  }

  static stripHtml(html) {
    const temporalDivElement = document.createElement("div");

    temporalDivElement.innerHTML = html;

    return temporalDivElement.textContent || temporalDivElement.innerText || "";
  }
  static convertTiming = (time24) => {
    const [hours, minutes] = time24.split(":");

    let hoursNumber = parseInt(hours, 10);

    const period = hoursNumber >= 12 ? "PM" : "AM";

    hoursNumber = hoursNumber % 12 || 12;

    const paddedHours = hoursNumber.toString().padStart(2, "0");
    const paddedMinutes = minutes.padStart(2, "0");

    return `${paddedHours}:${paddedMinutes} ${period}`;
  };
  static formatDate(value) {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    // Create a normal date string
    const normalDate = `${day}-${month}-${year}`;

    return normalDate;
  }
  static parseAndFormat = (dateTimeString) => {
    const [datePart, timePart] = dateTimeString.split("T");

    const formattedDate = this.formatDate(datePart);

    const formattedTime = this.convertTiming(timePart);

    return `${formattedDate} ${formattedTime}`;
  };

  static parseAndFormat2 = (dateTimeString) => {
    const [datePart, timePart] = dateTimeString.split(" ");

    const formattedDate = this.formatDate(datePart);

    const formattedTime = this.convertTiming(timePart);

    return `${formattedDate} ${formattedTime}`;
  };

  static formatDateStringAndTime = (dateTimeString) => {
    const date = new Date(dateTimeString);

    return date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(" ", " ")
      .replace(",", ",");
  };

  static convertTo24HourFormat(timeString) {
    const [time, period] = timeString.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (period === "PM" && hours !== 12) {
      hours += 12; // Convert PM hours (except 12) to 24-hour format
    } else if (period === "AM" && hours === 12) {
      hours = 0; // Convert 12 AM to 00:00 hours
    }

    return new Date(
      `1970-01-01T${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:00`
    );
  }
  static getDayOfWeek(dateString) {
    const date = new Date(dateString);
    const dayOfWeek = date.getDay();
    const dayNames = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    const dayName = dayNames[dayOfWeek];

    return dayName;
  }

  static getReservIntervals(openingTime, closingTime, duration) {
    const intervals = [];
    let start = new Date(`1970-01-01T${openingTime}Z`);
    const end = new Date(`1970-01-01T${closingTime}Z`);

    if (end <= start) {
      end.setDate(end.getDate() + 1);
    }

    while (start <= end) {
      intervals.push(start.toISOString().substr(11, 5));
      start.setMinutes(start.getMinutes() + duration);
    }

    return intervals;
  }

  static getInBetweenDays = (dateRanges) => {
    return dateRanges.map((range) => {
      const startDate = new Date(range?.startDate);
      const endDate = new Date(range?.endDate);
      const days = [];
      const time = {
        startTime: startDate.toISOString().split("T")[1].split(".")[0],
        endTime: endDate.toISOString().split("T")[1].split(".")[0],
      };

      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        days.push(currentDate.toISOString().split("T")[0]);
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return {
        comments: range.comments,
        days: days,
        time: time,
      };
    });
  };

  static formatExceptionDatetime(datetime) {
    if (!datetime) return null;

    const date = new Date(datetime);

    if (isNaN(date)) {
      throw new Error("Invalid datetime string");
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  static convertMinutesToHours(minutes) {
    const altered = typeof minutes == "string" ? parseInt(minutes) : minutes;
    const hours = Math.floor(altered / 60);
    return hours;
  }
}
